import { Box, Button, Collapse, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useAuth } from '../../context/AuthContext/AuthContext'
// import loginImage from '../../assets/images/login.jpeg'
import loginImage from '../../assets/images/login2.svg'
import styled from '@emotion/styled'
import InputField from '../../components/forms/InputField'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { loginValidationSchema } from '../../validations/loginValidation'
import InputPassword from '../../components/forms/InputPassword'
import Link from '../../components/Link'
import { useNavigate } from 'react-router-dom'
import useTranslate from '../../utils/i18n'

const ImageWrapper = styled(Box)({
  width: '100%',
  maxWidth: '260px',
  '& img': {
    width: '100%',
    objectFit: 'contain',
  },
})

const LoginPage = () => {
  const { t } = useTranslate()
  const { login } = useAuth()
  const [isError, setIsError] = useState(false)
  const [errMsg, setErrMsg] = useState('Something went wrong!')
  const navigate = useNavigate()

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginValidationSchema),
  })

  async function handleLogin(form) {
    try {
      await login(form)
      navigate('/home')
    } catch (error) {
      const errMsg = error.response
      if (errMsg) {
        setErrMsg(errMsg.message)
      }
      setIsError(true)
      console.log(error.name)
    }
  }

  return (
    <Box height={'100%'} mx={'-16px'}>
      <Box
        height={'80px'}
        width={'100%'}
        sx={{
          backgroundColor: ({ palette }) => palette.primary.main,
          borderBottomRightRadius: '60px',
        }}
      ></Box>
      <Box my={3} display={'flex'} justifyContent={'center'} width={'100%'}>
        <ImageWrapper>
          <img src={loginImage} alt="Login logo" loading="lazy" />
        </ImageWrapper>
      </Box>
      <Box mx={'1rem'} display={'block'}>
        <Collapse in={isError}>
          <Box
            width={'100%'}
            sx={{
              backgroundColor: ({ palette }) => palette.error.light,
              borderRadius: 2,
              p: 3,
              mb: 3,
            }}
          >
            <Typography fontWeight={500} color="white" fontSize={'14px'} textAlign={'center'}>
              {errMsg}
            </Typography>
          </Box>
        </Collapse>
        <Typography variant="h3" mb={2}>
          {t('signIn')}
        </Typography>
        <form onSubmit={handleSubmit(handleLogin)}>
          <InputField
            name="email"
            control={control}
            errors={errors}
            label={t('email')}
            placeholder={'myemail@mail.com'}
          />
          <InputPassword
            name="password"
            control={control}
            errors={errors}
            label={t('password')}
            placeholder={'********'}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{
              my: 2,
              fontWeight: 700,
              color: 'white',
              minHeight: '48px',
            }}
          >
            {t('signIn')}
          </Button>
        </form>

        <Typography fontWeight={700} textAlign="center">
          {t('or')}
        </Typography>
        <Typography textAlign="center" mt={1}>
          {t('noHaveAccount')}{' '}
          <Link href={'/register'} sx={{ fontWeight: 700 }}>
            {t('register')}
          </Link>
        </Typography>
      </Box>
    </Box>
  )
}

export default LoginPage
